---
label: Distance Heatmap
category: alignments
icon: GridIcon
keywords: [heatmap, heat map, distance, matrix, jc69, hky85, tn93]
addedInVersion: "0.0.0"
---

# MSA Heat Map

The heat map displays a pairwise distance matrix for an alignment as a color
grid. Each cell represents the evolutionary distance between two sequences,
computed using substitution models. Darker cells indicate greater distance.

The heat map tab is available for alignments with three or more sequences.

## How to Access

1. Open an alignment with 3 or more sequences from the file tree.
2. Click the **Heatmap** tab in the viewer header.

## Toolbar Controls

### Distance Model

Select the substitution model used to compute pairwise distances.

- **JC69** (Jukes-Cantor) — assumes equal substitution rates. Available for all
  sequence types. A good default for quick comparisons.
- **HKY85** (Hasegawa-Kishino-Yano) — accounts for different transition and
  transversion rates. Available for nucleotide alignments only.
- **TN93** (Tamura-Nei) — distinguishes between the two types of transitions in
  addition to transversions. Available for nucleotide alignments only. Use this
  when transition/transversion bias matters.

### Gap Deletion

Controls how gaps are handled during distance computation.

- **Pairwise** — excludes gapped positions on a per-pair basis. Each pair of
  sequences uses the maximum amount of available data.
- **Complete** — excludes any column that contains a gap in any sequence. All
  pairs are compared using the same set of positions.

### Export

Click the export button to save the heat map as an image.

## Tips

- Use **pairwise** gap deletion for alignments with many gaps. This preserves
  more data for each comparison.
- Use **complete** gap deletion when you need all comparisons to be based on
  exactly the same alignment columns.
- **JC69** is a reasonable default for a quick overview. Switch to **TN93** for
  nucleotide data when you need to account for transition/transversion bias.
- Hover over any cell to see the exact distance value and which sequences are
  being compared.
